import { TGetChartResponse } from '../../../repositories/valuation-market-analytics/v1/get-chart';
import { IChartState } from '../../../types/charts';

export interface IPrepareDataForCharts {
  chartPrice: TGetChartResponse;
  chartDemand: TGetChartResponse;
  chartSupply: TGetChartResponse;
  chartMortgage: TGetChartResponse;
  prevChartsData: IChartState;
}

export function prepareDataCharts({
  chartPrice,
  chartDemand,
  chartSupply,
  chartMortgage,
  prevChartsData,
}: IPrepareDataForCharts) {
  return {
    prices: chartPrice.statusCode === 200 ? chartPrice.response : prevChartsData.prices,
    demand: chartDemand.statusCode === 200 ? chartDemand.response : prevChartsData.demand,
    supply: chartSupply.statusCode === 200 ? chartSupply.response : prevChartsData.supply,
    mortgage: chartMortgage.statusCode === 200 ? chartMortgage.response : prevChartsData.mortgage,
  };
}
